import { Link } from 'react-router-dom';
import { getTrending } from '@/lib/catalog';
import { categoryList } from '@/mocks/categories';

export default function NotFoundPage() {
  const picks = getTrending(4);

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <div className="flex-1 w-full px-4 md:px-8 pt-20 pb-16 flex flex-col items-center justify-center text-center">
        <p className="text-6xl md:text-8xl font-black text-primary-100 select-none">404</p>
        <h1 className="mt-2 text-xl md:text-2xl font-bold text-foreground-950">这个页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm leading-6 text-foreground-500">
          链接可能已失效或输入有误，不如回首页看看最近更新的影视作品。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <Link
            to="/"
            className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm flex items-center gap-2 whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          {categoryList.map((item) => (
            <Link
              key={item.key}
              to={item.path}
              className="h-10 px-4 rounded-md border border-background-300 bg-background-50 text-xs text-foreground-700 flex items-center gap-1.5 whitespace-nowrap hover:border-accent-400 transition-colors"
            >
              <i className={item.icon} />
              {item.label}
            </Link>
          ))}
        </div>

        <div className="mt-10 w-full max-w-3xl">
          <p className="text-xs text-foreground-400 mb-4">大家都在看</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {picks.map((film) => (
              <Link key={film.id} to={`/detail/${film.id}`} className="group text-left">
                <div className="w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={film.poster}
                    alt={`${film.title} 封面`}
                    title={`${film.title} ${film.genre}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <p className="mt-2 text-xs font-medium text-foreground-900 truncate">{film.title}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}